import React, { useEffect } from 'react'
import { Route, Switch, useHistory } from 'react-router-dom'
import ViewBooking from './ViewBooking'
import ManageBooking from './ManageBooking'
import getCurrentUser from '../../utils/getCurrentUser'

const ManageBookingRoot = () => {
	const history = useHistory()
	const userDetails = getCurrentUser()


	return userDetails && Object.keys(userDetails).length !== 0 ? (
		<>
			<>
					<Switch>
						<Route
							exact
							path='/manage-booking'
							render={() => {
								history.push('/manage-booking/list')
							}}
						/>
						<Route
							exact
							path='/manage-booking/list'
							component={ManageBooking}
						/>
						<Route
							exact
							path='/manage-booking/:awbNo/:ubrNumber?'
							component={ViewBooking}
						/>
					</Switch>
			</>
		</>
	) : (
		<></>
	)
}

export default ManageBookingRoot
